module.exports = __webpack_public_path__ + "img/avatar-s-10.fd8c2d21.jpg";